import { useMemo } from 'react';
import { Resource } from '@go-shared/types/groupBooking';
import { VenueResourceRequest } from '@go-shared/types/zod/groupBooking';

function calculateQuickCostOfBooking(
  quickResources: (Omit<VenueResourceRequest, '_id' | 'description'> & { price: number })[]
): number {
  if (!quickResources || quickResources.length === 0) return 0;

  let totalCost = 0;

  quickResources.forEach(res => {
    const itemTotal = res.price * res.amount;
    totalCost += itemTotal;
  });

  return totalCost;
}

export function useTotalFunction(useLegacy: boolean, resources?: Resource[]) {
  const total = useMemo(() => {
    if (useLegacy) return 0;
    if (resources && resources.length > 0) {
      return calculateQuickCostOfBooking(
        resources.map(r => ({
          ...r,
          price: r.price || 0,
        }))
      );
    }
    return 0;
  }, [resources, useLegacy]);

  return {
    functionTotal: total,
  };
}
